const firebaseConfig = {
    apiKey: "AIzaSyC_UfZckF4JUROEj7JA3JWbgevnpMKdfWA",
    authDomain: "tourism-react.firebaseapp.com",
    projectId: "tourism-react",
    storageBucket: "tourism-react.appspot.com",
    messagingSenderId: "220313848186",
    appId: "1:220313848186:web:2a034a2e158e0925566ec3"
  };
export default firebaseConfig;  